<template>
  <div class="content my-3">
      <div class="resumoTable d-flex flex-column">
        <div class="header d-flex flex-row justify-space-between mx-4 mb-4">
          <div class="title d-flex flex-column">
            <h3 class="h3 font-weight-bold">Resumo crédito</h3>
            <section class="subtitle-2 grey--text text--darken-1 mt-n2">Resumo Crédito Financeiro — Sigplani</section>
          </div>
          <div class="actions d-flex flex-row">            
            <v-btn @click="doLoad(anoBase)" class="mr-2 elevation-4">
              <v-icon left>mdi-refresh</v-icon>
              <span class="font-weight-medium">Atualizar</span>
            </v-btn>            
          </div>
        </div>
        <div class="d-flex flex-row w-30">
          <year-select style="width: 150px" @change="doLoad"/>      
          <unidade-select
            v-model="unidade"
            class="ml-3"
            style="max-width: 280px;"
            @change="doLoad(anoBase)"
            @unidades="unidadeList = $event"
          ></unidade-select>
        </div>
        <table-v :cols="resumoCols" :opts="opts" :rows="resumo" height="130" :disablePagination="true"></table-v>      
      </div>
      <div class="statusTable d-flex  flex-column">
        <div class="header d-flex flex-row justify-space-between mx-4 my-4">
          <div class="title d-flex flex-column">
            <h3 class="h3 font-weight-bold">Status faturamento</h3>
            <section class="subtitle-2 grey--text text--darken-1 mt-n2">Status do faturamento incentivado</section>
          </div>
        </div>
        <table-v :cols="produtoCols" :opts="opts" :rows="produtos" height="450"></table-v>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "table-v": () => import("@/components/table-v.vue"),
    "year-select": () => import("@/components/year-select.vue"),
    "unidade-select": () => import("@/components/unidade-select.vue"),
  },
  computed: {
    ...mapGetters(["clientId", "isClient"]),
    pageTitle: function () {
      return this.$route.meta.name;
    },
    produtoCols: function () {
      return [
        {
          key: "produtoId",
          name: "Código",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "abreviacao",
          name: "Produto",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "incentivo",
          name: "Incentivo",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "jan",
          name: "JAN",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "fev",
          name: "FEV",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "mar",
          name: "MAR",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "abr",
          name: "ABR",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "mai",
          name: "MAI",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "jun",
          name: "JUN",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "jul",
          name: "JUL",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "ago",
          name: "AGO",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "set",
          name: "SET",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "out",
          name: "OUT",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "nov",
          name: "NOV",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: "dez",
          name: "DEZ",
          type: this.$fieldTypes.TEXT,
        },
      ];
    },
    resumoCols: function() {
      return [
        {
          key: `${this.anoBase}-01`,
          name: "JAN",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-02`,
          name: "FEV",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-03`,
          name: "MAR",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-04`,
          name: "ABR",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-05`,
          name: "MAI",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-06`,
          name: "JUN",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-07`,
          name: "JUL",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-08`,
          name: "AGO",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-09`,
          name: "SET",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-10`,
          name: "OUT",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-11`,
          name: "NOV",
          type: this.$fieldTypes.TEXT,
        },
        {
          key: `${this.anoBase}-12`,
          name: "DEZ",
          type: this.$fieldTypes.TEXT,
        },
      ]
    },
  },  
  data: function () {
    return {
      produtos: [],
      resumo: [],
      opts: {},
      anoBase: null,
      unidade: null,
      unidadeList: [],
    };
  },
  methods: {
    doLoad(anoBase) {
      this.anoBase = anoBase;
      const resource = this.apiResource(`/v1/faturamento/statuscalculo/${this.clientId}`);
      const meses = [
            "jan",
            "fev",
            "mar",
            "abr",
            "mai",
            "jun",
            "jul",
            "ago",
            "set",
            "out",
            "nov",
            "dez",
          ];      
          
      let query = `anoBase=${anoBase}`;
      if (this.unidade) {
        const id = this.unidade.id || this.unidade;
        query += `&unidade=${id}`;
      }

      return resource.get({ query }).then((response) => {
        this.produtos = response.produtos.map(({ status, ...rest }) => {
          return meses.reduce((prev, mes, index) => {
            const key = `${anoBase}-${(index + 1)
              .toString()
              .padStart(2, "0")}`;
            return {
              ...prev,
              [mes]: key in status ? status[key] : "--",
            };
          }, rest);
        });

        const resumo = Object.entries(response.resumo);          
        const mapper = resumo.reduce((prev, [key, val]) => {
        return {
          ...prev,
            [key]: val
          };
        }, {       
          [`${anoBase}-01`]: "--",
          [`${anoBase}-02`]: "--",
          [`${anoBase}-03`]: "--",
          [`${anoBase}-04`]: "--",
          [`${anoBase}-05`]: "--",
          [`${anoBase}-06`]: "--",
          [`${anoBase}-07`]: "--",
          [`${anoBase}-08`]: "--",
          [`${anoBase}-09`]: "--",
          [`${anoBase}-10`]: "--",
          [`${anoBase}-11`]: "--",
          [`${anoBase}-12`]: "--",
        });     

        this.resumo = [mapper];
      })
    },
  },
  watch: {
    clientId: function () {
      this.doLoad(this.anoBase);
    },
  },
};
</script>
